import { english } from "./english";
import { spanish } from "./spanish";

export const languages = {
  en: english,
  es: spanish,
};
